"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 26 26",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--background-color, transparent)",
  d: "M4 8v10a4 4 0 0 0 4 4h10c2.21 0 4-1.789 4-3.998V7.996A3.996 3.996 0 0 0 18 4H8a4 4 0 0 0-4 4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.8 16.35V4.4H7.5a3.1 3.1 0 0 0-3.1 3.1v11a3.1 3.1 0 0 0 3.1 3.1h11a3.1 3.1 0 0 0 3.1-3.1v-11a3.1 3.1 0 0 0-3.1-3.1h-1.275v11.941c0 1.032-1.215 1.583-1.991.903l-2.204-1.932-2.244 1.944c-.777.674-1.986.122-1.986-.907M18.5 3A4.5 4.5 0 0 1 23 7.5v11a4.5 4.5 0 0 1-4.5 4.5h-11A4.5 4.5 0 0 1 3 18.5v-11A4.5 4.5 0 0 1 7.5 3zm-8.3 1.4h5.625v11.5l-2.004-1.756a1.2 1.2 0 0 0-1.577-.005L10.2 15.911zm-.331 11.798",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CollectionSingleIcon26.js.map